// extracted by mini-css-extract-plugin
module.exports = {"title":"style_title__2HDU5","standaloneAlertContainer":"style_standaloneAlertContainer__1en6V","alert":"style_alert__mPh63","buttonGroup":"style_buttonGroup__293-d"};